import React, { useState, useEffect } from "react";

import { _Img as Img } from "./ProgressiveImage.style";

const ProgressiveImage = ({ placeholderSrc, src, ...props }) => {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || src);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setImgSrc(src);
  }, [src]);

  return (
    <Img
      {...{ src: imgSrc, ...props }}
      alt={props.alt || ""}
      className={placeholderSrc && imgSrc === placeholderSrc ? "loading" : "loaded"}
    />
  );
};
export default ProgressiveImage;